/**
 * Ticket Z14: Bestätigungsseite nach einer Weiterbildungsanfrage.
 * Nicht für Suchmaschinen bestimmt.
 */

import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

const TITLE = "Anfrage eingegangen | creategy";

export const Route = createFileRoute("/100-tage/weiterbildung/danke")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Ihre Anfrage zu Kursen und Trainings ist bei uns eingegangen.",
      },
      { property: "og:title", content: TITLE },
      {
        property: "og:description",
        content: "Ihre Anfrage zu Kursen und Trainings ist bei uns eingegangen.",
      },
      { property: "og:type", content: "website" },
    ],
  }),
  component: WeiterbildungDankePage,
});

function WeiterbildungDankePage() {
  return (
    <Layout>
      <section>
        <div className="section-y mx-auto w-full max-w-[1400px] px-6 md:px-12">
          <h1 className="heading-h1 text-primary">Vielen Dank für Ihre Anfrage.</h1>
          <p className="mt-8 max-w-[68ch] font-body text-base leading-relaxed text-foreground md:text-lg">
            Ihre Angaben sind bei uns eingegangen. Wir sehen uns Ihre Auswahl an und melden uns
            in der Regel innerhalb eines Werktags mit einem passenden Vorschlag. Die Anfrage ist
            weiterhin unverbindlich.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/100-tage"
              className="inline-flex items-center justify-center rounded-sm bg-brand-button px-6 py-3 font-display text-sm font-extrabold text-foreground transition-opacity hover:opacity-90"
            >
              Zurück zur Übersicht
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
